import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('home');

  const mainLinks = [
    { label: t('footer_spreadsheet'), to: '/spreadsheet' },
    { label: t('footer_guides'), to: '/guides' },
    { label: t('footer_reviews'), to: '/reviews' },
    { label: t('footer_shipping'), to: '/shipping' },
    { label: t('footer_coupon'), to: '/coupon' },
    { label: t('footer_warehouse'), to: '/warehouse' },
    { label: t('footer_qc'), to: '/qc' },
    { label: t('footer_safety'), to: '/safety' },
    { label: t('footer_comparison'), to: '/comparison' },
    { label: t('footer_faq'), to: '/faq' },
  ];

  const legalLinks = [
    { label: t('footer_about'), to: '/about' },
    { label: t('footer_contact'), to: '/contact' },
    { label: t('footer_privacy'), to: '/privacy-policy' },
    { label: t('footer_terms'), to: '/terms' },
    { label: t('footer_disclaimer'), to: '/disclaimer' },
  ];

  const langLinks = [
    { label: t('footer_lang_pt'), to: '/pt' },
    { label: t('footer_lang_de'), to: '/de' },
    { label: t('footer_lang_en'), to: '/en' },
  ];

  return (
    <footer className="bg-foreground-950 text-foreground-300">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block">
              <span className="text-xl font-bold text-background-50 tracking-tight">
                CSSBuy<span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              {t('footer_tagline')}
            </p>
            <div className="mt-4 flex gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-lg bg-foreground-800 hover:bg-foreground-700 flex items-center justify-center transition-colors"
                aria-label="Main Website"
              >
                <i className="ri-external-link-line text-foreground-400"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 uppercase tracking-wider mb-4">
              {t('footer_links')}
            </h4>
            <ul className="space-y-2.5">
              {mainLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-background-100 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 uppercase tracking-wider mb-4">
              {t('footer_legal')}
            </h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-background-100 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 uppercase tracking-wider mb-4">
              {t('footer_languages')}
            </h4>
            <ul className="space-y-2.5">
              {langLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-background-100 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <p className="text-xs text-foreground-500 text-center">
            {t('footer_tagline')} | &copy; {new Date().getFullYear()} cssbuybr.lat
          </p>
        </div>
      </div>
    </footer>
  );
}